<template>
  <header class="app-header shadow-sm border-bottom py-2">
    <div class="container-fluid d-flex align-items-center justify-content-end px-4">
      <div class="user-dropdown dropdown">
        <a
          class="user-profile-btn"
          href="#"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <div class="user-avatar-sm me-2">
            {{ user?.email?.charAt(0).toUpperCase() }}
          </div>
          <span class="user-email d-none d-sm-inline">{{ user?.email }}</span>
          <font-awesome-icon
            icon="caret-down"
            class="ms-2 small opacity-50"
          />
        </a>
        <ul class="dropdown-menu dropdown-menu-end shadow border-0 mt-2 p-2">
          <li>
            <router-link
              id="my-account-link"
              to="/dashboard/account"
              class="dropdown-item rounded p-2"
            >
              <font-awesome-icon
                icon="user"
                class="me-2 text-primary opacity-75"
              />
              {{ $t('header.nav.account') }}
            </router-link>
          </li>
          <li>
            <router-link
              id="availability-link"
              to="/dashboard/availability"
              class="dropdown-item rounded p-2"
            >
              <font-awesome-icon
                icon="business-time"
                class="me-2 text-primary opacity-75"
              />
              {{ $t('header.nav.availability') }}
            </router-link>
          </li>
          <li
            v-if="user?.roles.includes('ROLE_ADMIN')"
            class="dropdown-divider mx-2"
          ></li>
          <li v-if="user?.roles.includes('ROLE_ADMIN')">
            <router-link
              id="admin-link"
              to="/dashboard/admin"
              class="dropdown-item rounded p-2"
            >
              <font-awesome-icon
                icon="users-gear"
                class="me-2 text-primary opacity-75"
              />
              {{ $t('header.nav.admin') }}
            </router-link>
          </li>
          <li class="dropdown-divider mx-2"></li>
          <li>
            <a
              id="logout-link"
              href="#"
              class="dropdown-item rounded p-2 text-danger"
              @click="logout"
            >
              <font-awesome-icon
                icon="sign-out"
                class="me-2 opacity-75"
              />
              {{ $t('header.nav.logout') }}
            </a>
          </li>
        </ul>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import {User} from "../../types/User";
import {logout as doLogout} from "../../services/auth";

defineProps<{ user: User }>();

function logout() {
  doLogout();
  window.location.href = '/';
}
</script>

<style scoped lang="scss">
.app-header {
  height: 65px;
  background: #fff;
  display: flex;
  align-items: center;
  position: sticky;
  top: 0;
  z-index: 1000;
}

.user-profile-btn {
  display: flex;
  align-items: center;
  text-decoration: none;
  color: #495057;
  padding: 0.5rem 0.75rem;
  border-radius: 12px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f8f9fa;
  }
}

.user-avatar-sm {
  width: 32px;
  height: 32px;
  background: #eef2ff;
  color: #4c6ef5;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 0.85rem;
  border: 1px solid rgba(76, 110, 245, 0.1);
}

.user-email {
  font-size: 0.9rem;
  font-weight: 500;
}

.dropdown-item {
  font-size: 0.9rem;
  font-weight: 500;
  color: #495057;

  &:hover {
    background-color: #f8f9fa;
    color: #4c6ef5;
  }

  &.text-danger:hover {
    background-color: #fff5f5;
    color: #fa5252;
  }
}

.dropdown-divider {
  border-top-color: #f1f3f5;
}
</style>
